export function getCspNonce() {
  const meta = document.querySelector('meta[name="csp-nonce"]');
  return meta ? meta.getAttribute("content") : "";
}
